import { exclusiveLeads } from '@/mocks/homeData';

export default function ExclusiveLeads() {
  return (
    <section id="leads" className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-10 md:py-24">
        <div className="flex flex-col gap-5 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.32em] text-primary-600">LEADS DESK</p>
            <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              独家线索
            </h2>
          </div>
          <p className="max-w-md text-sm leading-loose text-foreground-600">
            这里放的是还在核对、但已经值得关注的线索。不急着下结论，先把时间、来源和疑点记清楚。
          </p>
        </div>

        <ol className="mt-12 space-y-9 md:space-y-12">
          {exclusiveLeads.map((lead) => (
            <li key={lead.date} className="grid grid-cols-1 gap-3 md:grid-cols-[150px_1fr] md:gap-10">
              <div className="flex items-center gap-2 text-sm tabular-nums text-foreground-500 md:pt-1">
                <i className="ri-calendar-line text-base"></i>
                {lead.date}
              </div>
              <div className="relative border-l border-background-300 pl-6 pb-1 md:pl-8">
                <span className="absolute -left-[5px] top-2 h-2.5 w-2.5 rounded-full bg-accent-500"></span>
                <h3 className="font-heading text-lg text-foreground-950 md:text-xl">{lead.title}</h3>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
                  {lead.text}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {lead.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-300 px-3 py-1 text-[11px] text-foreground-600"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}